import type { Recipients } from 'owa-editor-sonora-types';
import type RecipientWellWithFindControlViewState from 'owa-recipient-types/lib/types/RecipientWellWithFindControlViewState';
import type EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

const TO_WELL_INDEX = 0;
const CC_WELL_INDEX = 1;
const BCC_WELL_INDEX = 2;

export default function getRecipientsFromRecipientWells(
    recipientWells: RecipientWellWithFindControlViewState[],
    fromAddress: string
): Recipients {
    return {
        toRecipients: getRecipientsFromWell(recipientWells[TO_WELL_INDEX], fromAddress),
        ccRecipients: getRecipientsFromWell(recipientWells[CC_WELL_INDEX], fromAddress),
        bccRecipients: getRecipientsFromWell(recipientWells[BCC_WELL_INDEX], fromAddress),
    };
}

function getRecipientsFromWell(
    well: RecipientWellWithFindControlViewState,
    fromAddress: string
): EmailAddressWrapper[] {
    if (well?.recipients) {
        return well.recipients.reduce((result, recipient) => {
            if (recipient.persona.EmailAddress.EmailAddress !== fromAddress) {
                result.push(recipient.persona.EmailAddress);
            }
            return result;
        }, [] as EmailAddressWrapper[]);
    }

    return [];
}
